import { ErrorNotificationIcon } from "@/assets/icons";
import { useToast } from "@/store/useToast";

export const showDeleteLastPhotoToast = () => {
    const showToast = useToast((state) => state.show);
    showToast({
        icon: <ErrorNotificationIcon />,
        msg:
            <>
                ❗Невозможно удалить последнее фото
                <br />
                <br />
                В вашем профиле должно быть хотя бы одно фото. Добавьте новое, прежде чем удалить это.
            </>
    })
}
